export interface PaymentRoutesData {
	id: number;
	type: string;
	paymentmethod: string;
	authoption: string;
	route: string;
	scheme: string;
	region: string;
	currency: string;
	statusView: React.ReactNode;
}

export const ColumnPaymentRoutesModule = [
	{
		Header: "Type",
		accessor: "type",
	},
	{
		Header: "Payment method",
		accessor: "paymentmethod",
	},
	{
		Header: "Auth option",
		accessor: "authoption",
	},
	{
		Header: "Route",
		accessor: "route",
	},
	{
		Header: "Scheme",
		accessor: "scheme",
	},
	{
		Header: "Region",
		accessor: "region",
	},
	{
		Header: "Currency",
		accessor: "currency",
	},
	{
		Header: "Status",
		accessor: "statusView",
	},
];
